export const LP_DISPLAY_TYPE_LIST = "list";
export const LP_DISPLAY_TYPE_TILE = "tile";
export const LP_DISPLAY_TYPE_GAMEBOARD = "gameboard";


export const LP_HEADER_TYPE_TRADITIONAL = "traditional";
export const LP_HEADER_TYPE_FLOATING_RIBBON = "floating_ribbon";

export const LP_OVERALL_SCORE_TYPE_NONE = "none";
export const LP_OVERALL_SCORE_TYPE_HIDDEN = "hidden";
export const LP_OVERALL_SCORE_TYPE_AVERAGE = "average";
export const LP_OVERALL_SCORE_TYPE_WEIGHTED = "weighted";

export const LP_NAVIGATION_TYPE_LINEAR = "linear";
export const LP_NAVIGATION_TYPE_OPEN = "open";
export const LP_NAVIGATION_TYPE_FIRST_ANY_LAST = "first_any_last";

export const LP_BADGE_DISPLAY_HIDDEN = "hidden";
export const LP_BADGE_DISPLAY_HEADER = "header";
export const LP_BADGE_DISPLAY_BITE_MENU = "bite_menu";
export const LP_BADGE_DISPLAY_HEADER_AND_BITE = "header_and_bite_menu";

export const LP_PRIMARY_KPI_DISPLAY_HIDDEN = "hidden";
export const LP_PRIMARY_KPI_DISPLAY_LEARNING_PLAN_BITE = "learning_plan_bite";
export const LP_PRIMARY_KPI_DISPLAY_BITE_MENU = "bite_menu";
export const LP_PRIMARY_KPI_DISPLAY_LEARNING_PLAN_BITE_AND_BITE_MENU = "learning_plan_bite_and_bite_menu";

export const LP_GAMEBOARD_HOTSPOT_TYPE_CHECK_ROLLOVER = "check_rollover";
export const LP_GAMEBOARD_HOTSPOT_TYPE_CHECK_LABEL = "check_label";
export const LP_GAMEBOARD_HOTSPOT_TYPE_SMALL_ICON = "small_icon";
export const LP_GAMEBOARD_HOTSPOT_TYPE_SMALL_ICON_LABEL = "small_icon_label";
export const LP_GAMEBOARD_HOTSPOT_TYPE_SMALL_ICON_RECTANGLE_BUTTON = "small_icon_rectangle_button";
export const LP_GAMEBOARD_HOTSPOT_TYPE_LARGE_ICON = "large_icon";
export const LP_GAMEBOARD_HOTSPOT_TYPE_LARGE_ICON_LABEL = "large_icon_label";
export const LP_GAMEBOARD_HOTSPOT_TYPE_ROUND_ICON_LABEL = "round_icon_label";
export const LP_GAMEBOARD_HOTSPOT_TYPE_ROUND_ICON = "round_icon";


/** WEBPACK FOOTER **
 ** ./src/constants/learningPlanConstants.js
 **/